import React from 'react';
import QuestionCard from '../questions/QuestionCard';
import { GameSessionReview } from '../../services/api';
import { QuestionApiModel } from '../../types/questions';

interface GameSessionReviewPanelProps {
  review: GameSessionReview;
}

const GameSessionReviewPanel: React.FC<GameSessionReviewPanelProps> = ({ review }) => {
  return (
    <div className="space-y-6">
      {review.questions.map((item) => {
        const transformedQuestion: QuestionApiModel = {
          id: item.question.id,
          year: item.question.year,
          exam_type: item.question.exam_type,
          question_number: item.question.question_number,
          sub_question: 'N/A',
          question_type: item.question.question_type,
          vce_area_of_study: item.question.vce_area_of_study,
          question_text: item.question.question_text,
          option_a: item.question.option_a,
          option_b: item.question.option_b,
          option_c: item.question.option_c,
          option_d: item.question.option_d,
          correct_answer: item.question.correct_answer,
          difficulty_rating: item.question.difficulty_rating,
          worked_solution: item.question.worked_solution ?? undefined,
          tags: item.question.tags ?? [],
          option_e: item.question.option_e ?? undefined,
          progress: undefined,
        };

        const isCorrect = item.is_correct;
        const selectedAnswer = item.selected_answer ?? '';

        return (
          <div
            key={item.attempt_id}
            className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700"
          >
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                  Question {item.question_number} · {transformedQuestion.year} Exam {transformedQuestion.exam_type}
                </p>
                <div className="text-sm text-gray-600 dark:text-gray-300 mt-1">
                  {selectedAnswer
                    ? (
                      <span>
                        Your answer: <span className="font-semibold">{selectedAnswer}</span>
                      </span>
                    )
                    : (
                      <span className="italic text-gray-500 dark:text-gray-400">
                        No answer submitted
                      </span>
                    )}
                </div>
              </div>
              <span
                className={`inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full ${
                  isCorrect
                    ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200'
                    : 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200'
                }`}
              >
                {isCorrect ? 'Correct' : 'Incorrect'}
              </span>
            </div>
            <div className="p-4 sm:p-6">
              <QuestionCard
                question={transformedQuestion}
                showAnswer
                workedSolution={transformedQuestion.worked_solution ?? undefined}
                initialSelectedAnswer={selectedAnswer || undefined}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GameSessionReviewPanel;
